import { Button } from '@forwardflow/ui-v2'
import { useState } from 'react'
import { BusinessDetailsForm } from '@forwardflow/modules/onboarding/steps/business-details/BusinessDetailsForm'
import { useOrganizationDetails } from '@forwardflow/queries/organization.queries'
import { IBusinessDetails } from '@forwardflow/types/onboarding'

const OrganizationDetails = () => {
   const [isEditing, setIsEditing] = useState(false)
   const { data, mutate } = useOrganizationDetails({})

   // const removeBrandLogoHandler = async () => {
   //    setLogoUrl(null)
   //    setImageRemoving(true)
   //    const response = await OnboardingService.removeBrandLogo()
   //    setImageRemoving(false)
   //    message.success('Image Removed successfully')
   //    return response
   // }

   // const uploadBrandLogoHandler = async (options: any) => {
   //    const { file, onSuccess, onError } = options
   //    setImageUploading(true)
   //    try {
   //       if (!file) {
   //          console.error('File is undefined or null!')
   //          if (onError) onError(new Error('File is undefined or null'))
   //          setImageUploading(false)
   //          return
   //       }
   //       const actualFile = file.originFileObj || file

   //       const formData = new FormData()
   //       formData.append('file', actualFile, actualFile.name)

   //       const response = await OnboardingService.uploadBrandLogo(formData)

   //       if (response && response?.businessDetails?.logoUrl) {
   //          setLogoUrl(response?.businessDetails?.logoUrl)
   //       }

   //       if (onSuccess) {
   //          message.success('Image Uploaded successfully')
   //          onSuccess(response, file)
   //       }
   //    } catch (error) {
   //       console.error('Upload Error:', error)
   //       if (onError) {
   //          onError(error)
   //       }
   //    } finally {
   //       setImageUploading(false)
   //    }
   // }

   const handleEdit = () => {
      setIsEditing(true)
   }

   const handleCancel = () => {
      setIsEditing(false)
      mutate()
   }

   return (
      <div className="flex flex-col flex-1">
         <div className="flex items-center justify-between py-6 pl-10 pr-10 mb-8 border-b border-white/20">
            <div>
               <p className="text-[22px] font-medium whitespace-nowrap pb-8">
                  Organization details
               </p>
               <div className="flex items-center justify-between gap-x-5">
                  <p className="text-[12px] text-gray-400 max-w-[500px] pr-8">
                     Manage your organization's profile information, including
                     business details, contact information, and authorized
                     representative details
                  </p>
               </div>
            </div>

            {!isEditing ? (
               <Button
                  onClick={handleEdit}
                  className="!h-10 !rounded !mt-4 flex items-center gap-4 max-w-32"
               >
                  Edit
               </Button>
            ) : (
               <div className="flex gap-4 mt-4">
                  <Button
                     // isDisabled={isLoading}
                     onClick={handleCancel}
                     className="!h-10 !rounded px-7 mb-5 !mt-0 max-w-40 bg-white/10 border-primary/10 hover:border-primary/10 hover:bg-white/20"
                  >
                     Cancel
                  </Button>
                  <Button
                     // isLoading={isLoading}
                     // isDisabled={isLoading}
                     // onClick={handleSubmit}
                     className="!h-10 !rounded px-7 mb-5 !mt-0 max-w-40"
                  >
                     Save
                  </Button>
               </div>
            )}
         </div>
         <BusinessDetailsForm
            businessDetails={
               (data?.businessDetails as unknown as IBusinessDetails) || null
            }
            disabled={!isEditing}
         />
      </div>
   )
}

export default OrganizationDetails
